// extracted by mini-css-extract-plugin
export var block = "styles-module--block--f1a9f";
export var boneArrow = "styles-module--boneArrow--17a1e";
export var date = "styles-module--date--f76a4";
export var prev = "styles-module--prev--90d7d";
export var value = "styles-module--value--0eb91";
export var wrapper = "styles-module--wrapper--b94fd";